// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"dd01bcdf","787":"5855812e"}[chunkId] + ".chunk.js";
};